/// <amd-module name="Feed/Legacy/Protocols/Common/IPackageDetailsProps" />
import { FeedView, Package, PackageVersion, PackageVersionMetrics, PackageMetrics } from "Feed/Common/Contracts/Feed";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IPackageDetailsProps {
    pageContext: IVssPageContext;
    feed: Feed;
    packageSummary: Package;
    packageVersion: PackageVersion;
    protocol: IPackageProtocol;
    packageVersionMetrics?: PackageVersionMetrics;
    packageMetrics?: PackageMetrics;
    feedViews?: FeedView[];
    experiments?: { [key: string]: boolean };
    isSmartDependenciesEnabled?: boolean;
    isProvenanceEnabled?: boolean;
    isMetricsEnabled?: boolean;
    isMetricsLoading?: boolean;
}
